import React, { forwardRef } from "react";

import { ForwardRefType, QAProps } from "@multiweb/types/react";
import { ButtonProvider, ButtonProviderProps } from "../ButtonProvider";
import { Icon, IconColor, IconProps, IconThemeVariant } from "../Icon";
import { Layout, LayoutProps, SpacingSize } from "../Layout";

export type IconButtonProps =
    { iconVariant?: IconThemeVariant }
    & Omit<IconProps, "variant">
    & Pick<ButtonProviderProps, "shadow" | "outline" | "backgroundColor" | "onClick" | "onDoubleClick" | "onMouseDown" | "onMouseUp" | "onMouseOut" | "invalid" | "cursor" | "variant">
    & Pick<LayoutProps, "spacingSize">
    & QAProps;

/** Tlačítko v podobě ikony */
export const IconButton: ForwardRefType<HTMLButtonElement, IconButtonProps> = forwardRef<HTMLButtonElement, IconButtonProps>(({
    onClick,
    onDoubleClick,
    onMouseDown,
    onMouseUp,
    onMouseOut,
    title,
    disabled,
    backgroundColor,
    shadow,
    outline,
    spacingSize = SpacingSize.xs,
    invalid,
    cursor,
    color = IconColor.colorPrimary,
    variant,
    iconVariant,
    qa,
    ...restProps
}, ref) => {
    return (
        <ButtonProvider {...{ onClick, onDoubleClick, onMouseDown, onMouseUp, onMouseOut, title, ref, disabled, shadow, outline, backgroundColor, invalid, cursor, variant, qa }}>
            <Layout spacingSize={spacingSize}>
                <Icon {...restProps} disabled={disabled} color={color} variant={iconVariant} />
            </Layout>
        </ButtonProvider>
    );
});
